import Immutable from 'seamless-immutable';

export const contentTypeFilterCategory = 'contentType';

export const filters = Immutable({
  favoritesOnly: 'FAVORITES_ONLY',
  aliasOnly: 'ALIAS_ONLY',
  sharedExercises: 'SHARED_EXERCISES',
  exercisesContent: 'EXERCISES_CONTENT',
  educationContent: 'EDUCATION_CONTENT',
  specialty: 'SPECIALTY',
  bodyRegion: 'BODY_REGION',
  muscleGroup: 'MUSCLE_GROUP',
  objective: 'OBJECTIVE',
  position: 'POSITION',
  equipment: 'EQUIPMENT',
});
